import { render, staticRenderFns } from "./options.vue?vue&type=template&id=15b4243c&scoped=true&"
import script from "./options.vue?vue&type=script&lang=ts&"
export * from "./options.vue?vue&type=script&lang=ts&"
import style0 from "./options.vue?vue&type=style&index=0&id=15b4243c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4243c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
